/* Anacea : ajout au panier sans quitter la page, puis ouverture du tiroir panier.
   Tout bouton [data-ana-add="variantId"] ou [data-ana-add="id1,id2"]. */
(function () {
  function openDrawer(cart) {
    var drawer = document.querySelector('[data-drawer="drawer-cart"]');
    if (!drawer) { window.location.href = '/cart'; return; }
    document.dispatchEvent(new CustomEvent('theme:cart:change', { detail: { cart: cart }, bubbles: true }));
    drawer.dispatchEvent(new CustomEvent('theme:drawer:open', { bubbles: false }));
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-ana-add]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var ids = btn.getAttribute('data-ana-add').split(',').filter(Boolean);
    var plan = btn.getAttribute('data-selling-plan');
    if (!ids.length) return;
    var label = btn.innerHTML;
    btn.disabled = true;
    btn.textContent = 'Ajout en cours…';
    var items = ids.map(function (id) {
      var it = { id: Number(id), quantity: 1 };
      if (plan) it.selling_plan = Number(plan);
      return it;
    });
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ items: items }) })
      .then(function (r) { if (!r.ok) throw new Error('cart'); return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.disabled = false; btn.innerHTML = label;
        openDrawer(cart);
      })
      .catch(function () { btn.disabled = false; btn.innerHTML = label; window.location.href = '/cart'; });
  });
})();
